var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 153,
    viewBox: "0 0 100 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0829 12.0229L62.2672 3.43511L55.3843 8.01527L50.0886 0L44.8006 8.01527L37.9101 3.43511L35.102 12.0229L27.5781 9.73282L32.2863 26.0534H50.0886H67.8986L72.6067 9.73282L65.0829 12.0229Z",
    fill: "#CEB388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.112 18.458C39.5359 18.458 30.959 20.2443 30.959 22.4427V37.9924H69.265V22.4427C69.2421 20.2443 60.6728 18.458 50.112 18.458Z",
    fill: "#CEB388"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0885 41.9698C60.6665 41.9698 69.2415 40.1892 69.2415 37.9927C69.2415 35.7962 60.6665 34.0156 50.0885 34.0156C39.5106 34.0156 30.9355 35.7962 30.9355 37.9927C30.9355 40.1892 39.5106 41.9698 50.0885 41.9698Z",
    fill: "#4B4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 123.885L50.0038 152.763L100 123.885V66.1296L50.0038 37.2441L0 66.1296V123.885Z",
    fill: "url(#paint0_linear_1729_95)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7716 111.964C47.7745 111.964 45.8966 111.547 44.138 110.712C42.3794 109.877 40.9337 108.677 39.801 107.111C38.6833 105.546 38.0797 103.787 37.9902 101.833H45.144C45.3974 102.802 45.9488 103.593 46.7983 104.204C47.6627 104.815 48.6538 105.121 49.7716 105.121C51.2172 105.121 52.335 104.703 53.1249 103.869C53.9148 103.034 54.3097 101.96 54.3097 100.648C54.3097 99.3659 53.8775 98.2999 53.0131 97.45C52.1636 96.5853 51.098 96.1529 49.8163 96.1529C48.6389 96.1529 47.6255 96.466 46.7759 97.0922C45.9413 97.7184 45.3526 98.5384 45.0099 99.5523L38.9962 97.6737L42.752 78.9326H60.5246L57.1936 85.6195H48.0726L46.9771 90.7856C48.1098 90.2041 49.4959 89.9134 51.1353 89.9134C54.2352 89.9134 56.6869 90.9197 58.4902 92.9325C60.3085 94.9304 61.2176 97.5917 61.2176 100.916C61.2176 104.256 60.1594 106.932 58.0431 108.945C55.9268 110.958 53.1696 111.964 49.7716 111.964Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_95",
    x1: 50,
    y1: 37.2441,
    x2: 50,
    y2: 152.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAAF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D99E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel5);
export default __webpack_public_path__ + "static/media/_level-5.dfc9d28bce0b53ac99f8e2190089e130.svg";
export { ForwardRef as ReactComponent };